import { render, staticRenderFns } from "./WidgetAccountRow.vue?vue&type=template&id=fbee9af8&scoped=true&"
import script from "./WidgetAccountRow.vue?vue&type=script&lang=js&"
export * from "./WidgetAccountRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbee9af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fbee9af8')) {
      api.createRecord('fbee9af8', component.options)
    } else {
      api.reload('fbee9af8', component.options)
    }
    module.hot.accept("./WidgetAccountRow.vue?vue&type=template&id=fbee9af8&scoped=true&", function () {
      api.rerender('fbee9af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/userprofile/WidgetAccountRow.vue"
export default component.exports